import { Box, Typography, SxProps, Theme } from "@mui/material";
import { Home, Groups, Code, School } from "@mui/icons-material";
import { SectionContainer } from "../../../modules/SectionContainer/SectionContainer";
import { SectionTitle } from "../../../modules/SectionTitle/SectionTitle";

const features = [
  {
    icon: <Home sx={{ fontSize: 32, color: "#22A1B9" }} />,
    title: "フルリモート対応",
    description: "基本はフルリモートで働けます。場所を選ばず、自分のベストな環境で開発に集中できます。",
  },
  {
    icon: <Groups sx={{ fontSize: 32, color: "#22A1B9" }} />,
    title: "少数精鋭のフラットなチーム",
    description: "30名以下のフラットな組織。意思決定が速く、自分の提案がすぐ実装に繋がる環境です。",
  },
  {
    icon: <Code sx={{ fontSize: 32, color: "#22A1B9" }} />,
    title: "技術に自由な文化",
    description:
      "大手企業案件で実践されるモダン技術（AWS・TypeScript・React等）を日常的に扱います。コードレビューや技術共有が文化として根付いています。",
  },
  {
    icon: <School sx={{ fontSize: 32, color: "#22A1B9" }} />,
    title: "成長を支援する制度",
    description: "書籍購入補助 / 外部勉強会参加支援 / 資格取得支援",
  },
];

export const EnvironmentSection = () => {
  return (
    <SectionContainer sx={{ background: "#FFFFFF", padding: { md: "100px 0", xs: "60px 0" } }}>
      <SectionTitle sx={{ fontSize: { md: "40px", xs: "26px" } }}>働く環境</SectionTitle>

      <Box sx={featuresContainerSx}>
        {features.map((feature, index) => (
          <Box key={index} sx={featureCardSx}>
            <Box sx={iconContainerSx}>{feature.icon}</Box>
            <Typography sx={titleSx}>{feature.title}</Typography>
            <Typography sx={descriptionSx}>{feature.description}</Typography>
          </Box>
        ))}
      </Box>
    </SectionContainer>
  );
};

const featuresContainerSx: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: { md: "repeat(4, 1fr)", sm: "repeat(2, 1fr)", xs: "1fr" },
  gap: { md: "24px", xs: "16px" },
  marginTop: { md: "48px", xs: "32px" },
};

const featureCardSx: SxProps<Theme> = {
  background: "#f8f9fa",
  borderRadius: "12px",
  padding: { md: "32px 24px", xs: "24px 20px" },
  textAlign: "center",
  transition: "all 0.3s",
  "&:hover": {
    transform: "translateY(-4px)",
    boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
  },
};

const iconContainerSx: SxProps<Theme> = {
  marginBottom: "16px",
};

const titleSx: SxProps<Theme> = {
  fontSize: { md: "18px", xs: "16px" },
  fontWeight: 700,
  color: "#222222",
  marginBottom: "12px",
};

const descriptionSx: SxProps<Theme> = {
  fontSize: { md: "14px", xs: "13px" },
  color: "#666666",
  lineHeight: 1.8,
};
